import React from 'react';
import styled from '@emotion/styled';
import { fromThemeColors, ThemeColor } from '@sharefiledev/flow-web';
import {
	Component,
	defaultComponentDimensions,
	defaultLableFontSize,
	Field,
} from '../../../common/componentUtils';
import { MandatoryFieldIndicator } from '../MandatoryFieldIndicator';

export interface GenericFieldComponentProps {
	component: Component;
	field: Field;
	scale: number;
	width: number;
}

export const GenericFieldComponent = ({
	component,
	field,
	scale,
	width,
}: GenericFieldComponentProps) => {
	const { type, isRequired } = component;
	const { icon: Icon, label } = field;
	const { labelThresholdWidth } = defaultComponentDimensions[type];

	return (
		<>
			<IconLabelWrapper {...{ scale }}>
				<Icon size={16} color={fromThemeColors(ThemeColor.primaryText)({ theme: {} })} />
				{labelThresholdWidth < width && label && <Label>{label}</Label>}
			</IconLabelWrapper>
			{isRequired && (
				<MandatoryFieldIndicator
					displayOutside={labelThresholdWidth > width}
					scale={scale}
				/>
			)}
		</>
	);
};

const IconLabelWrapper = styled.div<{ scale: number }>`
	display: flex;
	align-items: center;
	color: ${fromThemeColors(ThemeColor.primaryText)({ theme: {} })};
	transform: ${({ scale }) => `scale(${scale})`};
`;

const Label = styled.span`
	padding-left: 8px;
	font-size: ${defaultLableFontSize}px;
`;
